
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOptionStatus'
import currencyOptionMixin from '@/mixin/currencyOption'
import orderDateOptionMixin from '@/mixin/orderDateOption'
import {
  getOrderList,
  orderExport,
  setOrder,
  setSuccessStatus
} from '@/api/order/settlement'
import {
  paymentOrderStatistics,
  setOneClickUnfreeze,
  setOneClickChange
} from '@/api/task/withdraw'
import { Form as ElForm } from 'element-ui'
import { notifiedStatusList, timeTypeList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import pagination from '@/components/Pagination/index.vue'
import orderDetail from './components/settlementDetail.vue'
import { delObjEmptyKey } from '@/utils'
import payoutWithdrawList from './components/payoutWithdrawList.vue'
import { getWithdrawInfo } from '@/api/order/payout'
import { setOrderStatusRules } from '@/utils/rules'
import { getCurrentDate } from '@/utils/dateTime'
import PicsUploader from '@/components/PicsUploader/index.vue'
import settlementReject from './components/settlementReject.vue'
import migrate from './components/migrate.vue'
import settlementBatchModify from './components/settlementBatchModify.vue'
import settlementBatchModifyState from './components/settlementBatchModifyState.vue'
import settlementBatchNotify from './components/settlementBatchNotify.vue'
import { getAccountGroupList } from '@/api/product/accountGroup'
import kick from './components/kickOut.vue'

@Component({
  name: 'settlementList',
  components: {
    pagination,
    orderDetail,
    payoutWithdrawList,
    PicsUploader,
    settlementReject,
    migrate,
    settlementBatchModify,
    settlementBatchModifyState,
    settlementBatchNotify,
    kick
  }
})
export default class extends mixins(
  productOptionMixin,
  currencyOptionMixin,
  orderDateOptionMixin
) {
  get language() {
    return AppModule.language
  }
  queryForm: any = {
    merchant_no: null,
    order_number: null,
    child_ordernumber: null,
    status: null,
    upstream_status: null,
    reverse_order: null,
    notify_status: null,
    product: null,
    min_amount: '',
    max_amount: '',
    source: null,
    bank_code: null,
    start_time: null,
    end_time: null,
    handle_time_unit: timeTypeList[0],
    product_type: 'settlement',
    product_account_group: null,
    multi_order_number: null,
    multi_child_ordernumber: null
  }
  setFormUnfreeze: any = {
    currency: '',
    upstream_status: null,
    status: null,
    remarks: null,
    google_code: ''
  }

  private setForm: any = {
    status: null,
    remarks: '',
    description: '',
    google_code: ''
  }
  private rules = setOrderStatusRules
  private statusList: any[] = []
  private notifiedStatusList = notifiedStatusList
  private orderStatusList: any[] = []
  private upstreamStatusList: any[] = []
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: boolean = false
  private loading: boolean = false

  private requiredErr: any = ''
  private requiredRemarks: any = ''
  private requiredStatus: any = ''
  private totalData: any = {
    transactions: {},
    volume: {}
  }
  // private total = {}
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }

  @Watch('queryForm.currency', { immediate: true })
  private watchCurrency() {
    this.setFormUnfreeze.currency = this.queryForm.currency
  }

  private currentOrdernumber: number | null = null
  private drawer: boolean = false
  private dialogVisible: boolean = false
  private dialogVisible1: boolean = false
  private dialogVisible2: boolean = false
  private dialogVisible3: boolean = false
  private dialogVisible4: boolean = false
  private dialogVisible5: boolean = false
  private expandedRows: any[] = []
  private show: boolean = false

  // 一键解冻
  private multilength: any = ''
  private changeOrder(val: any) {
    if (val) {
      let str = val.replace(/\n|\r\n/g, ',')
      let str1 = false
      str1 = str.includes('，')
      if (str1) {
        str = val.replace(/\，/g, ',')
      }
      // 转成数组并去掉空值
      this.multilength = str.split(',')
      this.multilength = this.multilength.filter((item: any) => {
        return item !== ''
      })
      let pattern = /([。！？；,.!?;，])\1$/
      if (pattern.test(str)) {
        let newStr = str.replace(pattern, '')
        this.queryForm.multi_order_number = newStr.split(',').join(',')
      } else {
        this.queryForm.multi_order_number = str.split(',').join(',')
      }
    } else {
      this.multilength = ''
    }
  }
  private opnekickUnfreezeShow: boolean = false
  private opnekickUnfreeze() {
    this.opnekickUnfreezeShow = true
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
    if (this.ordernumbers) {
      let arr = this.ordernumbers
      this.multilength = arr
      this.queryForm.multi_order_number = arr.join(',')
    }
    this.setFormUnfreeze.status = null
    this.setFormUnfreeze.remarks = null
    this.setFormUnfreeze.google_code = ''
    this.requiredErr = ''
    this.requiredRemarks = ''
    this.requiredStatus = ''
    if (this.dateType === 'Created Time' && !this.date) {
      this.date = getCurrentDate()
    }
    if (this.dateType === 'Success Time' && !this.successDate) {
      this.successDate = getCurrentDate()
    }
  }

  private multiChildlength: any = ''
  private changeChildOrder(val: any) {
    if (val) {
      let str = val.replace(/\n|\r\n/g, ',')
      let str1 = false
      str1 = str.includes('，')
      if (str1) {
        str = val.replace(/\，/g, ',')
      }
      // 转成数组并去掉空值
      this.multiChildlength = str.split(',')
      this.multiChildlength = this.multiChildlength.filter((item: any) => {
        return item !== ''
      })
      let pattern = /([。！？；,.!?;，])\1$/
      if (pattern.test(str)) {
        let newStr = str.replace(pattern, '')
        this.queryForm.multi_child_ordernumber = newStr.split(',').join(',')
      } else {
        this.queryForm.multi_child_ordernumber = str.split(',').join(',')
      }
    } else {
      this.multiChildlength = ''
    }
  }

  private closeOpnekickUnfreeze() {
    this.opnekickUnfreezeShow = false
    this.setFormUnfreeze.status = null
    this.setFormUnfreeze.remarks = null
    this.setFormUnfreeze.google_code = ''
    this.queryForm.multi_order_number = ''
    this.queryForm.multi_child_ordernumber = ''
    this.multilength = ''
    this.multiChildlength = ''
  }
  private async saveClickUnfreeze() {
    if (!this.queryForm.status) {
      this.requiredErr = 'Query status is required'
    } else if (
      this.queryForm.status &&
      (!this.setFormUnfreeze.remarks || !this.setFormUnfreeze.status)
    ) {
      this.requiredRemarks = 'Remarks is required'
      this.requiredStatus = 'Status is required'
    } else {
      ;(this.$refs.setFormUnfreeze as ElForm).validate(
        async (valid: boolean) => {
          if (valid) {
            this.loading = true
            this.flag = true
            if (
              this.queryForm.multi_order_number &&
              this.queryForm.multi_order_number.substr(-1) === ','
            ) {
              this.queryForm.multi_order_number =
                this.queryForm.multi_order_number.replace(/\S{1}$/, '')
            }
            if (
              this.queryForm.multi_child_ordernumber &&
              this.queryForm.multi_child_ordernumber.substr(-1) === ','
            ) {
              this.queryForm.multi_child_ordernumber =
                this.queryForm.multi_child_ordernumber.replace(/\S{1}$/, '')
            }

            const data: any = {
              ...this.setFormUnfreeze,
              filters: {
                order_number: this.queryForm.order_number,
                child_ordernumber: this.queryForm.child_ordernumber,
                merchant_no: this.queryForm.merchant_no,
                min_amount: this.queryForm.min_amount,
                max_amount: this.queryForm.max_amount,
                product_code: this.queryForm.product_code,
                product_account_no: this.queryForm.product_account_no,
                product_account_group: this.queryForm.product_account_group,
                status: this.queryForm.status,
                upstream_status: this.queryForm.upstream_status,
                reverse_order: this.queryForm.reverse_order,
                notify_status: this.queryForm.notify_status,
                start_time: this.queryForm.start_time,
                end_time: this.queryForm.end_time,
                success_start_time: this.queryForm.success_start_time,
                success_end_time: this.queryForm.success_end_time,
                multi_order_number: this.queryForm.multi_order_number,
                multi_child_ordernumber: this.queryForm.multi_child_ordernumber,
                product_type: 'settlement'
              }
            }
            delObjEmptyKey(data)
            await setOneClickUnfreeze(data)
              .then(() => {
                this.$message({
                  message: 'Operation successfully!',
                  type: 'success'
                })
                this.loading = false
                this.flagStr()
                this.closeOpnekickUnfreeze()
                this.select()
              })
              .catch(() => {
                this.loading = false
                this.flagStr()
              })
          }
        }
      )
    }
  }

  // 跳转地址
  private jumpAddress(row) {
    if (row.withdraw_info.coin_type === 'TRC20') {
      window.open(
        `https://tronscan.io/#/address/${row.withdraw_info.address}/transfers`
      )
    } else if (row.withdraw_info.coin_type === 'ERC20') {
      window.open(`https://etherscan.io/address/${row.withdraw_info.address}`)
    }
  }
  private hashJump(row) {
    if (row.product_account_type === 'trc20') {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    } else if (row.product_account_type === 'erc20') {
      window.open(`https://etherscan.io/tx/${row.upstream_ordernumber}`)
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      this.orderList = []
      await getOrderList(data).then((res: any) => {
        // this.total = res
        this.total = res.count
        this.orderList = res.results
        this.orderList.forEach((item: any) => {
          this.$set(item, 'subOrderList', [])
          if (this.expandedRows.indexOf(item.ordernumber) !== -1) {
            this.getWithdrawInfo(item)
          }
        })
        this.listLoading = false
        this.currentPage = this.currentPage
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private changeStatus(i) {
    if (i === 1) {
      this.show = true
    } else {
      this.show = false
    }
  }

  private selectList: any[] = []
  private handleSelectionChange(list) {
    this.selectList = list
  }

  private ordernumbers: any[] = []
  private openDialog2() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
    this.dialogVisible2 = true
  }

  private openDialog3() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].status === 2) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.dialogVisible3 = true
  }
  // 批量修改冻结订单状态
  private openDialog4() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].status === 3) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.dialogVisible4 = true
  }
  // 批量发送订单回调
  private openDialog5() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].status === 1 || this.selectList[i].status === 5) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.dialogVisible5 = true
  }

  private payRules = {
    google_code: [
      { required: true, message: 'Please input Google Code', trigger: 'blur' }
    ]
  }
  private async saveClickChange() {
    if (!this.queryForm.status) {
      this.requiredErr = 'Query status is required'
    } else if (
      this.queryForm.status &&
      (!this.setFormUnfreeze.remarks || !this.setFormUnfreeze.status)
    ) {
      this.requiredRemarks = 'Remarks is required'
      this.requiredStatus = 'Status is required'
    } else {
      ;(this.$refs.setFormUnfreeze as ElForm).validate(
        async (valid: boolean) => {
          if (valid) {
            this.loading = true
            this.flag = true
            if (
              this.queryForm.multi_order_number &&
              this.queryForm.multi_order_number.substr(-1) === ','
            ) {
              this.queryForm.multi_order_number =
                this.queryForm.multi_order_number.replace(/\S{1}$/, '')
            }
            if (
              this.queryForm.multi_child_ordernumber &&
              this.queryForm.multi_child_ordernumber.substr(-1) === ','
            ) {
              this.queryForm.multi_child_ordernumber =
                this.queryForm.multi_child_ordernumber.replace(/\S{1}$/, '')
            }
            const data: any = {
              ...this.setFormUnfreeze,
              filters: {
                order_number: this.queryForm.order_number,
                child_ordernumber: this.queryForm.child_ordernumber,
                merchant_no: this.queryForm.merchant_no,
                min_amount: this.queryForm.min_amount,
                max_amount: this.queryForm.max_amount,
                product_code: this.queryForm.product_code,
                product_account_no: this.queryForm.product_account_no,
                product_account_group: this.queryForm.product_account_group,
                status: this.queryForm.status,
                upstream_status: this.queryForm.upstream_status,
                reverse_order: this.queryForm.reverse_order,
                notify_status: this.queryForm.notify_status,
                start_time: this.queryForm.start_time,
                end_time: this.queryForm.end_time,
                success_start_time: this.queryForm.success_start_time,
                success_end_time: this.queryForm.success_end_time,
                multi_order_number: this.queryForm.multi_order_number,
                multi_child_ordernumber: this.queryForm.multi_child_ordernumber,
                product_type: 'settlement'
              }
            }
            delObjEmptyKey(data)
            await setOneClickChange(data)
              .then(() => {
                this.$message({
                  message: 'Operation successfully!',
                  type: 'success'
                })
                this.loading = false
                this.flagStr()
                this.closeOpnekickUnfreeze()
                this.select()
              })
              .catch(() => {
                this.loading = false
                this.flagStr()
              })
          }
        }
      )
    }
  }

  // 踢出队列
  private opnekickOut: boolean = false
  private openKickOut() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].is_in_queue !== null) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.opnekickOut = true
  }

  private isDisabled(row, index) {
    return row.status === 2 || row.status === 3 || row.notify_status !== 1
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      if (item.response) {
        return item.response.file_path
      } else {
        return item.url
      }
    })
  }

  private openDialog(orderInfo: any) {
    let { ordernumber, status, status_display } = orderInfo
    this.setForm = { ordernumber, status, status_display }
    // this.setForm.status = null
    this.dialogVisible = true
  }

  private info: any = {}
  private openDialog1(orderInfo: any) {
    this.info = orderInfo
    this.dialogVisible1 = true
  }

  private closeDialog() {
    this.dialogVisible = false
    this.dialogVisible1 = false
    this.dialogVisible2 = false
    this.dialogVisible3 = false
    this.dialogVisible4 = false
    this.dialogVisible5 = false
    this.opnekickOut = false
    this.hadleGetFilesListApi()
  }

  private openDrawer(ordernumber: number) {
    this.currentOrdernumber = ordernumber
    this.drawer = true
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private async setSuccessStatus() {
    this.loading = true
    this.flag = true
    let {
      google_code,
      description,
      remarks,
      status2: status,
      status_display
    } = this.setForm
    const data: any = {
      ordernumber: this.setForm.ordernumber,
      google_code,
      description,
      remarks,
      status,
      status_display
    }
    try {
      await setSuccessStatus(data).then(() => {
        if (this.language === 'en') {
          this.$message({
            message:
              'The task was created successfully, please contact another administrator for approval!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '任务创建成功，请联系其他管理员审批!',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '任務創建成功，請聯系其他管理員審批!',
            type: 'success'
          })
        }
        this.loading = false
        this.flagStr()
        this.closeDialog()
      })
    } catch (e) {
      this.loading = false
      this.closeDialog()
    }
  }

  private async setOrderStatus() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        let {
          ordernumber,
          status2: status,
          remarks,
          description,
          google_code,
          attach
        } = this.setForm
        const data: any = {
          ordernumber,
          status,
          remarks,
          description,
          google_code,
          attach
        }
        try {
          await setOrder(data).then(() => {
            if (this.language === 'en') {
              this.$message({
                message:
                  'The task was created successfully, please contact another administrator for approval!',
                type: 'success'
              })
            }
            if (this.language === 'zh_cn') {
              this.$message({
                message: '任务创建成功，请联系其他管理员审批!',
                type: 'success'
              })
            }
            if (this.language === 'zh_tw') {
              this.$message({
                message: '任務創建成功，請聯系其他管理員審批!',
                type: 'success'
              })
            }
            this.loading = false
            this.flagStr()
            this.closeDialog()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.currentOrdernumber = null
    // this.hadleGetFilesListApi()
  }

  private closeInfo() {
    this.drawer = false
  }

  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.reset()
  }

  private reset() {
    this.queryForm = {
      currency: this.queryForm.currency,
      merchant_no: null,
      order_number: null,
      child_ordernumber: null,
      start_time: null,
      end_time: null,
      status: null,
      upstream_status: null,
      reverse_order: null,
      notify_status: null,
      product: null,
      notify_start_time: null,
      notify_end_time: null,
      product_code: null,
      product_account_no: null,
      min_amount: '',
      max_amount: '',
      product_type: 'settlement',
      product_account_group: null
    }
    this.dateType = 'Created Time'
    this.date = getCurrentDate()
    this.notifyDate = getCurrentDate()
    this.successDate = getCurrentDate()
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
      this.paymentOrderStatistics()
    })
  }

  private async expandChange(row, expandedRows) {
    this.expandedRows = expandedRows.map(item => item.ordernumber)
    if (expandedRows.length > 0) {
      await this.getWithdrawInfo(row)
    }
  }

  private async getWithdrawInfo(row: any) {
    await getWithdrawInfo(row.ordernumber).then((res: any) => {
      row.subOrderList = res
    })
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
    this.paymentOrderStatistics()
  }

  // 出款统计
  private async paymentOrderStatistics() {
    try {
      let data: any = {
        ...this.queryForm
      }
      await paymentOrderStatistics(data).then((res: any) => {
        this.totalData = res
      })
    } catch (e) {}
  }

  private async exportData() {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await orderExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private queryName: any = ''
  private productNameChange() {
    this.queryForm.product_account_group = ''
    this.getProductAccountGroup(this.queryName)
  }

  // 远程查询
  private accountGroupList: any[] = []
  private async getProductAccountGroup(query: string) {
    this.queryName = query
    try {
      const data = {
        currency: this.queryForm.currency,
        product_code: this.queryForm.product_code,
        name: query,
        page_size: 50
      }
      await getAccountGroupList(data).then((res: any) => {
        this.accountGroupList = res.results
      })
    } catch (e) {}
  }

  private async init() {
    this.orderStatusList = await AppModule.GetOrderStatusList()
    this.upstreamStatusList = await AppModule.GetUpstreamStatusList()
    await AppModule.GetConstant().then((res: any) => {
      this.statusList = res.OUT_ORDER_STATUS_CHOICES
    })
    this.hadleGetFilesListApi()
    this.paymentOrderStatistics()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.init()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.settlement`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
